import type { RootState } from 'core/store';
import { select } from 'core/middlewares/utilities';

/**
 * Get the items from cart
 *
 */
export function* getCartItems() {
  const items: RootState['cart']['data']['items'] = yield select(
    ({ cart }: RootState) => cart.data.items,
  );

  return items || [];
}

export type CartItems = RootState['cart']['data']['items'];

/**
 * Get the hasItem flag from cart
 *
 */
export function* getCartHasItem() {
  const hasItem: RootState['cart']['hasItem'] = yield select(({ cart }: RootState) => cart.hasItem);

  return hasItem;
}

export type CartHasItem = RootState['cart']['hasItem'];

/**
 * Get the canAddItem flag from cart
 *
 */
export function* getCartCanAddItem() {
  const canAddItem: RootState['cart']['canAddItem'] = yield select(
    ({ cart }: RootState) => cart.canAddItem,
  );

  return canAddItem;
}

export type CartCanAddItem = RootState['cart']['canAddItem'];

/**
 * Get the meta data from cart
 *
 */
export function* getCartMetaItemUpdate() {
  const { meta }: RootState['cart']['itemUpdate'] = yield select(
    ({ cart }: RootState) => cart.itemUpdate,
  );

  return meta;
}

export type CartMetaItemUpdate = RootState['cart']['itemUpdate']['meta'];
